import { Empty, Icon } from 'ui';
// TODO: Strange import
import { EntityList } from 'features/channels';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useOrganizationsInfiniteQuery } from 'features/organizations/queries';

type P = {
  getPathToOrganizationDetail: (id: string) => string;
  groupId: string;
};

const OrganizationsList = ({ getPathToOrganizationDetail, groupId }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useOrganizationsInfiniteQuery({
    filter: { groupId, scope: 'groups' },
    pagination: { pageSize: 12 },
  });

  const organizations = data?.pages.flat().flatMap((organizationsPaginated) => organizationsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no churches to display here',
            title: 'No churches',
          }}
          image={<Icon icon="bank-line" />}
        />
      }
      entities={organizations?.map((organization) => ({
        data: organization,
        type: 'Organization',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToOrganizationDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isLoading}
    />
  );
};

export default OrganizationsList;
